import React, { useContext } from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import SideNav, { SIDEBAR_WIDTH, SIDEBAR_WIDTH_COLLAPSED, useSidebarCollapsed } from "./SideNav";
import EmbedContext from "../../context/Embed";

/**
 * Wraps app pages that should show the sidebar.
 * Shifts content right on md+ screens to account for the fixed sidebar.
 * The offset follows the same collapsed state as the sidebar (user toggle
 * persisted in localStorage, falling back to screen size).
 * hideSidebar: the page goes full width, no sidebar.
 */
function MainLayout({ children, hideSidebar = false }) {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up("md"));
  const { collapsed } = useSidebarCollapsed();
  const { isEmbed } = useContext(EmbedContext);

  const offset = isMd ? (collapsed ? SIDEBAR_WIDTH_COLLAPSED : SIDEBAR_WIDTH) : 0;

  // Embed mode, or a page that wants the full width (a restaurant's own
  // page): no sidebar, content spans the whole window.
  if (isEmbed || hideSidebar) {
    return (
      <Box component="main" sx={{ minHeight: "100vh" }}>
        {children}
      </Box>
    );
  }

  return (
    <>
      <SideNav />
      <Box
        component="main"
        sx={{
          ml: `${offset}px`,
          transition: "margin-left 0.2s ease",
          minHeight: "100vh",
        }}
      >
        {children}
      </Box>
    </>
  );
}

export default MainLayout;
